// src/services/productApi.js
import axios from 'axios';
import { API_BASES } from '../config';

const GATEWAY_BASE_URL = API_BASES.gateway; // ✅ usar el gateway

export const PRODUCTS_API = axios.create({
  baseURL: `${GATEWAY_BASE_URL}/api/products`,
  headers: { 'Content-Type': 'application/json' },
});

// === Interceptores ===
PRODUCTS_API.interceptors.request.use(config => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

PRODUCTS_API.interceptors.response.use(
  res => res,
  err => {
    if (err.response && [401, 403].includes(err.response.status)) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// === Endpoints ===
export function getProductById(id) {
  return PRODUCTS_API.get(`/${id}`);
}

export function createProduct(formData) {
  return PRODUCTS_API.post('', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function decideProduct(id, aprobar, comentario) {
  return PRODUCTS_API.put(`/${id}/decision`, { aprobar, comentario });
}

export function listPendingProducts(page = 0, size = 50) {
  return PRODUCTS_API.get('/pending', { params: { page, size } });
}

export function getProductsByStatus(estado, page = 0, size = 50) {
  return PRODUCTS_API.get('', { params: { estado, page, size } });
}

export function getAllProducts(page = 0, size = 50) {
  return PRODUCTS_API.get('', { params: { page, size } });
}

export function getMyProducts(page = 0, size = 50) {
  return PRODUCTS_API.get('/my-products', { params: { page, size } });
}

export function updateProduct(id, productData) {
  return PRODUCTS_API.put(`/${id}`, productData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function deleteProduct(id) {
  return PRODUCTS_API.delete(`/${id}`);
}

export function deleteProductFile(id, driveFileId) {
  return PRODUCTS_API.delete(`/${id}/files/${encodeURIComponent(driveFileId)}`);
}
